module.exports = __webpack_public_path__ + "img/courses4.d7820ffd.jpg";